import {Component, Input, OnInit} from '@angular/core';

import {LanguageService} from "@shared/services/language.service";
import { LanguageCode } from '@shared/view-models/language.viewmodel';

@Component({
  selector: 'am-select-language',
  templateUrl: './select-language.component.html',
})
export class SelectLanguageComponent implements OnInit {

  @Input() isVerticalDisplay = false;

  constructor(
    public languageService: LanguageService
  ) {
  }

  ngOnInit(): void {
  }

  onChangeLanguage(lang: LanguageCode) {
    this.languageService.current = lang;

    if (this.isVerticalDisplay) {

    }
    // else
      // window.location.reload();
  }

  isSelected(lang: string) {
    return this.languageService.current === lang;
  }

  getIconClass(lang: string): string {
    return 'tk-i-lang-' + lang;
  }

}
